import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86b6dd42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-style-panel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "background-image-wrapper" }
const _hoisted_4 = { class: "background-image" }
const _hoisted_5 = { class: "row" }

import { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTVideoElement } from '@/types/slides'
import { getImageDataURL } from '@/utils/image'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { getPptIdByUrl } from "@/utils/common";
import { uploadFile } from '@/api/combo'
import { useI18n } from 'vue-i18n'
import {
  uploadFileToOSS,
  getFileExtension
} from "@/utils/uploadOss";
import FileInput from '@/components/FileInput.vue'
import { Button } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoStylePanel',
  setup(__props) {

const { t, locale } = useI18n()
const slidesStore = useSlidesStore()
const { handleElement,pptId } = storeToRefs(useMainStore())

const handleVideoElement = handleElement as Ref<PPTVideoElement>

const { addHistorySnapshot } = useHistorySnapshot()

const updateVideo = (props: Partial<PPTVideoElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

// 设置视频预览封面
const setVideoPoster = async (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  const formData = new FormData()
  formData.append('file', imageFile)
  let fileType = getFileExtension(imageFile.name);
  const fileRes: any = await uploadFileToOSS('content', imageFile, 2, fileType)
  updateVideo({ poster: fileRes.name })
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.videoStylePanel.cover`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FileInput, {
        onChange: _cache[0] || (_cache[0] = files => setVideoPoster(files))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "content",
              style: _normalizeStyle({ backgroundImage: `url(${_unref(handleVideoElement).poster})` })
            }, [
              _createVNode(_component_IconPlus)
            ], 4)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Button), {
        style: {"flex":"1"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateVideo({ poster: '' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.videoStylePanel.recover`)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})